import { createFileRoute } from "@tanstack/react-router";
import { ScrollableContainer } from "@/components/ui/scrollbar";
import { useTranslation } from "react-i18next";
import { RoomDetail } from "@/components/room-detail";
import { MobilePageTitle } from "@/components/ui/mobile-page-title";

export const Route = createFileRoute("/(protected)/rooms/new/")({
  component: RouteComponent,
  loader: () => ({ hasActionButtons: true }),
});

function RouteComponent() {
  const { t } = useTranslation();
  return (
    <ScrollableContainer className="mt-0">
      <div className="flex min-h-full flex-col px-6 md:px-6 lg:py-2">
        <MobilePageTitle className="mt-5 mb-4">
          {t("pages:dashboard.sidebar.new_room")}
        </MobilePageTitle>
        <RoomDetail />
      </div>
    </ScrollableContainer>
  );
}
